import { combineReducers } from 'redux';
import branchReducer from './branchReducer';
import depositReducer from './depositReducer';
import loginReducer from './loginReducer';
import orderReducer from './orderReducer';
import pickupTimeReducer from './pickupTimeReducer';
import posReducer from './posReducer';
import websock from './websocketReducer';
import yWebsock from "./yWebsocketReducer";

export default combineReducers({
  loginReducer,
  depositReducer,
  posReducer,
  websock,
  yWebsock,
  orderReducer,
  pickupTimeReducer,
  branchReducer,
});
